import axios from './templateInstance'
import { DesignTemplate, FlattedDesignTemplate } from '@/types/designTemplate'

export const flattenDesignTemplate = (template: DesignTemplate): FlattedDesignTemplate => ({
  id: template.id,
  name: template.name,
  description: template.description || '',
  thumbnail: template.thumbnail_url || '',
  isActive: template.is_active,
  isGeneric: template.is_generic,
  priority: template.priority ?? 0,
  version: template.version ?? 1,
  sections: template.sections || [],
  placeholderCount: template.placeholder_count ?? 0,
  elementCount: template.element_count ?? 0,
  origin: template.origin,
})

const getDesignTemplates = async (): Promise<FlattedDesignTemplate[]> => {
  try {
    const response: any = await axios.get(`/design-templates/`)
    const contents: DesignTemplate[] = response?.data?.contents || response?.data || []
    if (!Array.isArray(contents)) return []

    return contents.map(flattenDesignTemplate).sort((a, b) => {
      if (a.priority !== b.priority) return a.priority - b.priority
      return a.name.localeCompare(b.name)
    })
  } catch (error) {
    console.error('Error fetching design templates:', error)
    return []
  }
}

export default getDesignTemplates
